import { css } from '@emotion/react';
import { type FC } from 'react';
import { ButtonStyle } from '~/_shared/baseComponents/buttons/button/button.types';
import { useTranslation } from '~/_shared/utils/hooks';
import { UploadMethodComponent } from './uploadMethod.component';

const secondaryUploadContainerStyle = (isMobileScreen: boolean) => css({
  display: 'flex',
  flexDirection: isMobileScreen ? 'column' : 'row',
  gap: 16,
});

const uploadMethodStyle = (isMobileScreen: boolean) => css({
  minWidth: 0,
  width: isMobileScreen ? '100%' : '50%',
});

type UploadMethodsProps = Readonly<{
  isLoading: boolean;
  isMobileScreen: boolean;
  onStartBlankClick: () => void;
  onStartGoogleSheetsClick: () => void;
}>;

export const UploadMethodsComponent: FC<UploadMethodsProps> = ({
  isLoading,
  isMobileScreen,
  onStartBlankClick,
  onStartGoogleSheetsClick,
}) => {
  const [t] = useTranslation();

  return (
    <div css={secondaryUploadContainerStyle(isMobileScreen)}>
      <UploadMethodComponent
        buttonLabel={t('Start Blank')}
        buttonStyle={ButtonStyle.Secondary}
        css={uploadMethodStyle(isMobileScreen)}
        isDisabled={isLoading}
        onClick={onStartBlankClick}
        title={t('Manually create a New Map from scratch with no data set.')}
      />
      <UploadMethodComponent
        buttonLabel={t('Google Sheets')}
        buttonStyle={ButtonStyle.Success}
        css={uploadMethodStyle(isMobileScreen)}
        isDisabled={isLoading}
        onClick={onStartGoogleSheetsClick}
        title={t('Create a New Map with Google Sheets.')}
      />
    </div>
  );
};
